import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { ModelType } from '@shared/constants/model-type.enum';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(private http: HttpClient) { }

    private handleServerError(err: HttpErrorResponse) {

        if (!err.ok) {
            let errdescription = err.message;

            if (err.status == 404) {
                if (err.error && err.error.title)
                    errdescription = err.error.title;
            }
        }

        return throwError(() => err);
    }

    get(path: string, modelType: ModelType): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Model-Type': modelType
            }),
        };

        return this.http
            .get(`${environment.appApiURL}${path}`, httpOptions)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    getBlob(path: string, modelType: ModelType): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Model-Type': modelType
            }),
            responseType: 'blob' as 'json'
        };

        return this.http
            .get(`${environment.appApiURL}${path}`, { ...httpOptions, responseType: 'blob' })
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            ) as Observable<Blob>;
    }

    post(path: string, body: object = {}, modelType: ModelType): Observable<any> {

        var jsonOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Model-Type': modelType
            }),
        };

        return this.http
            .post(
                `${environment.appApiURL}${path}`,
                JSON.stringify(body),
                jsonOptions
            )
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    put(path: string, body: any = {}, modelType: string): Observable<any> {

        var jsonOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Model-Type': modelType
            }),
        };
        return this.http
            .put(
                `${environment.appApiURL}${path}`,
                JSON.stringify(body),
                jsonOptions
            )
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }
}


